(() => {
    jQuery(document).ready(($) => {
        console.log('ready')
        const burger = $('button.burger')

        burger.click(function() {
            $(this).toggleClass('burger--active')

            if ($(this).hasClass('burger--active')) {
                $('.js-header-burger-open-title').removeAttr('hidden')
                $('.js-header-burger-close-title').attr('hidden', true)
                $('.header-menu').css({'opacity': 1, 'visibility': 'visible'})

            } else {
                $('.js-header-burger-open-title').attr('hidden', true)
                $('.js-header-burger-close-title').removeAttr('hidden')
                $('.header-menu').css({'opacity': 0, 'visibility': 'hidden'})
            }
        })
    })
})();